import { api } from "../client";
import { endpoints } from "../endpoints";

export const rowsOf = (data) => Array.isArray(data) ? data : data?.results ?? [];
export const recordsService = {
  async read(url, params, signal) {
    return (await api.request({ url, params, signal, safeRead: true })).data;
  },
  async import(kind, data, signal) {
    return (await api.request({ url: kind === "exam" ? endpoints.records.uploadExam : endpoints.records.uploadAttendance,
      method: "POST", data, signal })).data;
  },
  async status(username, reason, signal) {
    const response = await api.request({ url: reason ? endpoints.management.deactivate : endpoints.management.reactivate,
      method: "POST", signal, data: reason ? { username: String(username), reason } : { username: String(username) } });
    // A confirmed 204 also succeeds; failed requests still reject in the client.
    return response.data || {};
  },
  async offline(filters, signal) {
    return (await api.request({ url: endpoints.records.offline, params: filters, signal, safeRead: true })).data;
  },
};
